import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  QACopyReciept,
  QAIOSPayemntReciept
} from "../../core/et3-table/UserCustomHelpers";
import { reduce } from "et3-type-guards";

export const QA_IOS_RECEIPT_TOKENS_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "uniqueId"
  },
  {
    headerName: "Receipt",
    field: "receipt",
    flex: 3,
    renderCell: (params: GridValueGetterParams) => {
      const receipt = reduce(() => `${params.row.receipt}`, "");
      return <QAIOSPayemntReciept receipt={receipt} />;
    }
  },
  {
    headerName: "Copy Receipt",
    field: "copyReceipt",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      const receipt = params.row.receipt;
      return <QACopyReciept receipt={receipt} />;
    }
  }
];
